import React from "react";
import FieldConfig from "../../../proto/field-config";
import FieldDropdown from "../../../generic/dropdown/dropdown";
import FieldOffice_PopoverMenuMore from "./components/popover/popover-menu-more";

export default class FieldOffice extends FieldDropdown {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Office";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption          = _.get(config,'addNoValueOption',false);

        // Label for no value option
        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','Please select');

        // default placeholder for FORM element
        this.placeholder            = _.get(config,'placeholder','Please select');

        this.noOptionsLabel         = _.get(config,'noOptionsLabel','No locations');

        this.icon               = 'i5-crm-contact';

        this.isSearchable       = true;

        this.components.PopoverMenuMore = FieldOffice_PopoverMenuMore

        this.classes.PopoverMenu = 'min-w-200'
    }

    getOptions() {
        return gd.session.offices.toOptions()
    }

}
